import React from 'react';

import LogoutSuccessfulFeature from '@features/logout-successful';

function ExternalElearningLogoutSuccessfulPage() {
  return <LogoutSuccessfulFeature />;
}

export default ExternalElearningLogoutSuccessfulPage;
